"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SkeletonLoader: true,
  BREAKPOINT_HORIZONTAL_SIDEPANEL: true,
  BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY: true
};
Object.defineProperty(exports, "BREAKPOINT_HORIZONTAL_SIDEPANEL", {
  enumerable: true,
  get: function () {
    return _breakpoints.BREAKPOINT_HORIZONTAL_SIDEPANEL;
  }
});
Object.defineProperty(exports, "BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY", {
  enumerable: true,
  get: function () {
    return _breakpoints.BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY;
  }
});
Object.defineProperty(exports, "SkeletonLoader", {
  enumerable: true,
  get: function () {
    return _SkeletonLoader.SkeletonLoader;
  }
});
var _SkeletonLoader = require("./components/SkeletonLoader");
var _breakpoints = require("./constants/breakpoints");
var _defaultTranslations = require("./constants/defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./constants/defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
var _PersonalMenu = require("./PersonalMenu");
Object.keys(_PersonalMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PersonalMenu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PersonalMenu[key];
    }
  });
});
